import { useEffect } from 'react';
//https://css-tricks.com/dangers-stopping-event-propagation/
//https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
//
const useOutsideElement = (ref, callback, triggers = [], eventType = 'mousedown', options) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      const targetNode = event?.target;
      const targetElement =
        targetNode?.nodeType === Node.TEXT_NODE ? targetNode.parentElement : targetNode instanceof Element ? targetNode : null;

      if (ref.current && targetElement && !ref.current.contains(targetElement)) {
        callback(targetElement, event);
      }
    }
    // Bind the event listener
    document.addEventListener(eventType, handleClickOutside, options);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener(eventType, handleClickOutside, options);
    };
  }, [ref, eventType, options, ...triggers]);
};

export default useOutsideElement;
